/*
Controller: Foundry

Operations:
  checkisFoundryUnique
  getFoundryById
  updateFoundryDetail
  uploadFoundryLogo
  deleteFoundryLogo
  giveAiConsent
*/
var Api = require('../config')
var FoundryDetailResponseDef = require('../definitions/FoundryDetailResponse')
var FoundryImageRequestDef = require('../definitions/FoundryImageRequest')
var AiConsentRequestDef = require('../definitions/AiConsentRequest')

var Foundry = (function () {
  /*
  Operation: checkisFoundryUnique
  Check foundry is unique or not
  Parameters:
    foundryName: Name of the foundry
  Responses:
    HTTP 200: Foundry is Unique or not
    HTTP 403: Operation not permitted
  */
  function checkisFoundryUniqueFoundry (foundryName) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryName) {
          throw new Error('foundryName: Missing parameter')
        }
        if (foundryName && !(typeof foundryName === 'string')) {
          throw new Error('foundryName: Wrong type: Got "' + (typeof foundryName) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundries/checkUnique/{foundryName}'
      path = path.replace('{' + 'foundryName' + '}', foundryName)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFoundryById
  Get foundry details
  Parameters:
    foundryId: Id of the foundry
  Responses:
    HTTP 200: Foundry found
    HTTP 403: Operation not permitted
    HTTP 404: Foundry not found
  */
  function getFoundryByIdFoundry (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundries/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: updateFoundryDetail
  update foundry detail
  Parameters:
    foundryId: Id of the foundry
    bodyRequest: foundryDetails for update
  Responses:
    HTTP 200: Foundry updated
    HTTP 403: Operation not permitted
    HTTP 404: Foundry not found
  */
  function updateFoundryDetailFoundry (foundryId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        FoundryDetailResponseDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/foundries/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'put',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: uploadFoundryLogo
  Upload foundry logo to the platform
  Parameters:
    foundryId: Id of the foundry
    bodyRequest: Foundry logo&#x2F;banner object
  Responses:
    HTTP 200: Successful upload
    HTTP 400: Upload failed
    HTTP 403: Operation not permitted
    HTTP 413: Uploaded file too large
    HTTP 415: Wrong file type
  */
  function uploadFoundryLogoFoundry (foundryId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        FoundryImageRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/foundries/{foundryId}/logo'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: deleteFoundryLogo
  Delete foundry logo
  Parameters:
    logoId: Id of foundry logo
    foundryId: Id of the foundry
  Responses:
    HTTP 200: OK
    HTTP 400: Failed to delete foundry logo
    HTTP 403: Operation not permitted
    HTTP 404: Image not found
  */
  function deleteFoundryLogoFoundry (logoId, foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!logoId) {
          throw new Error('logoId: Missing parameter')
        }
        if (logoId && !(typeof logoId === 'string')) {
          throw new Error('logoId: Wrong type: Got "' + (typeof logoId) + '", but expected: "string"')
        }
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/foundries/{foundryId}/logo/{logoId}'
      path = path.replace('{' + 'logoId' + '}', logoId)
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'delete',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: giveAiConsent
  Give AI agreement consent for a foundry
  Parameters:
    foundryId: Id of the foundry
    bodyRequest: AI consent request object
  Responses:
    HTTP 200: AI consent given successfully
    HTTP 400: Invalid request data
    HTTP 401: Unauthorized
    HTTP 403: Operation not permitted
    HTTP 404: Foundry or AI agreement not found
  */
  function giveAiConsentFoundry (foundryId, bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
        AiConsentRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/foundries/{foundryId}/aiConsent'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['checkisFoundryUnique'] = checkisFoundryUniqueFoundry
  ret['getFoundryById'] = getFoundryByIdFoundry
  ret['updateFoundryDetail'] = updateFoundryDetailFoundry
  ret['uploadFoundryLogo'] = uploadFoundryLogoFoundry
  ret['deleteFoundryLogo'] = deleteFoundryLogoFoundry
  ret['giveAiConsent'] = giveAiConsentFoundry
  return ret
})()

module.exports = Foundry
